import { render } from "./index.vue?vue&type=template&id=72a0354c&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Modules/Authentication/ForgetPassword/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "72a0354c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72a0354c', __exports__)) {
    api.reload('72a0354c', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=72a0354c&ts=true", () => {
    api.rerender('72a0354c', render)
  })

}


export default __exports__